import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { EventVenueEntity } from '@core/entities';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EventVenueService {
  data: any;
  private readonly _http = inject(HttpClient);
  private readonly _apiUrl = environment.apiUrl;

  find(): Observable<EventVenueEntity[]> {
    return this._http.get<any>(`${this._apiUrl}/getEventVenues`).pipe(map((res) => res.result));
  }

  get(id: number): Observable<EventVenueEntity> {
    return this._http.get<any>(`${this._apiUrl}/getEventVenueById/${id}`).pipe(map((res) => res.result));
  }

  create(data: any): Observable<any> {
    return this._http.post<any>(`${this._apiUrl}/createEventVenue`, data).pipe(map((res) => res.result));
  }

  update(id: number, data: any): Observable<any> {
    return this._http.put<any>(`${this._apiUrl}/updateEventVenue/${id}`, data).pipe(map((res) => res.result));
  }

  delete(id: number): Observable<any> {
    return this._http.delete<any>(`${this._apiUrl}/deleteEventVenue/${id}`);
  }
}
